import DtoConverter from 'scripts/application/dto_converters/diagnostics_config_converter';
import FullStory from 'scripts/lib/fullstory';

export default class DiagnosticsConfigurationGatewayObserver {
  constructor() {
    this.fullstory = FullStory;
  }

  onFetchSuccess(dto) {
    this.handleDto(dto);
  }

  onBroadcast(dto) {
    this.handleDto(dto);
  }

  handleDto(dto) {
    const diagnosticsConfig = DtoConverter.fromDto(dto);
    if (diagnosticsConfig.fullStoryDeactivated) {
      this.fullstory.deactivate();
    } else {
      this.fullstory.reactivate();
    }
  }
}
